import type { ReactNode } from "react";
import { cn } from "./cn";

type Color = "accent" | "good" | "warn";

const dotColor: Record<Color, string> = {
  accent: "bg-accent",
  good: "bg-good",
  warn: "bg-warn",
};

export function StatusPill({
  children,
  color = "accent",
  light,
}: {
  children: ReactNode;
  color?: Color;
  light?: boolean;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-1",
        "border border-dashed font-mono text-[11px] uppercase tracking-wider",
        light ? "border-dash-l text-tl-2" : "border-dash-d text-td-2",
      )}
    >
      <span className={cn("size-1.5 rounded-full", dotColor[color])} />
      {children}
    </span>
  );
}
